// Constantes estáticas da superfície de Relatório (abas, seções e opções de
// filtro). Extraídas de RelatorioIndex.vue sem alteração de conteúdo.

export const WORKSPACE_TAB_KEYS = [
  'report',
  'activity',
  'duty',
  'monthly',
  'consent',
  'team',
  'targets',
];
export const REPORT_SECTION_KEYS = ['published', 'visits', 'offers', 'ccv'];
export const REPORT_TAB_KEYS = ['imoveis', 'bairros'];
export const ANALYTICS_SOURCE_KEYS = [
  'all',
  'web',
  'mobile',
  'wa',
  'email',
  'api',
];
export const AMBASSADOR_CONSENT_PURPOSE = 'agent_terms_acceptance';
export const LEGACY_AMBASSADOR_CONSENT_PURPOSE = 'ambassador_beta';

export const workspaceTabs = [
  {
    value: 'report',
    label: 'Relatório',
    icon: 'i-lucide-bar-chart-3',
  },
  {
    value: 'activity',
    label: 'Minha Atividade',
    icon: 'i-lucide-activity',
  },
  {
    value: 'duty',
    label: 'Plantão',
    icon: 'i-lucide-headphones',
  },
  {
    value: 'monthly',
    label: 'Relatório mensal',
    icon: 'i-lucide-calendar-range',
  },
  {
    value: 'consent',
    label: 'Embaixador',
    icon: 'i-lucide-shield-check',
  },
  {
    value: 'team',
    label: 'Desempenho da equipe',
    icon: 'i-lucide-users',
    permissions: ['administrator', 'report_manage'],
  },
  {
    value: 'targets',
    label: 'Metas',
    icon: 'i-lucide-target',
    permissions: ['administrator', 'report_manage'],
  },
];

export const baseReportSections = [
  {
    value: 'published',
    label: 'Anúncios publicados',
    description:
      'Total acumulado de imóveis publicados na Imudei até o momento e o tráfego, considerando o período selecionado.',
  },
  {
    value: 'visits',
    label: 'Visitas',
    description: 'Visitas agendadas versus realizadas.',
  },
  {
    value: 'offers',
    label: 'Propostas',
    description: 'Propostas enviadas versus aceitas.',
  },
  {
    value: 'ccv',
    label: 'Compromissos de compra e venda',
    description:
      'Acompanhe compromissos de compra e venda vinculados às propostas aceitas no período selecionado.',
  },
];

export const analyticsSourceOptions = [
  { value: 'all', label: 'Todas as origens' },
  { value: 'web', label: 'Web' },
  { value: 'mobile', label: 'Mobile' },
  { value: 'wa', label: 'WhatsApp' },
  { value: 'email', label: 'E-mail' },
  { value: 'api', label: 'API' },
];

export const dutySortOptions = [
  { value: 'older-tta', label: 'Mais antigos' },
  { value: 'latest-tta', label: 'Mais recentes' },
  { value: 'client-name', label: 'Cliente' },
];

export const exportFormats = [
  { id: 'csv', label: 'CSV', icon: 'i-lucide-file-down' },
  { id: 'pdf', label: 'PDF', icon: 'i-lucide-file-text' },
  { id: 'xlsx', label: 'Excel', icon: 'i-lucide-table-2' },
];
